import axios from 'axios'
import { confirm, showMsg, msg } from '@/utils/msg';
// import store from '@/store'
// import { getToken } from '@/utils/auth'
import initCacheFun from '@/utils/cache';
import { getBrowserKey } from '@/utils/browserUtil';

const $cache = initCacheFun(false);
const $session = initCacheFun(true);

const defServiceName = "Base";
const bossServiceName = "Boss";
const childDomainName = process.env.VUE_APP_BASE_CHILD_DOMAIN_NAME;
var routeDomain = "";
if (location && location.origin && childDomainName) {
    var apiDomainArr = location.origin.split(".");
    if (apiDomainArr[1] == "deepagens" || apiDomainArr[1] == "qiweiwiki"){
        routeDomain = childDomainName + "." + apiDomainArr.slice(1).join(".");
    }
}
const serviceUrlHash = {
    [defServiceName]: routeDomain || process.env.VUE_APP_BASE_API,
    [bossServiceName]: routeDomain || process.env.VUE_APP_BOSS_API
};
//错误是否提示
const errTip = true;

// create an axios instance
const service = axios.create({
    serviceName: defServiceName,
    baseURL: serviceUrlHash[defServiceName],// url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 50000, // request timeout
    errTip
})

function noAuth(){
    ////暂不用判断登录
    //store.dispatch('user/resetToken').then(() => {
    location.reload()
    //})
}

// request interceptor
service.interceptors.request.use(
    config => {
        ////暂不用判断登录
        // // do something before request is sent
        // if (store.getters.token) {
        //     // let each request carry token
        //     // ['X-Token'] is a custom headers key
        //     // please modify it according to the actual situation
        //     config.headers['token'] = getToken()
        // }
        config.headers['scoketId'] = $session.get('scoketId') || '';
        config.headers['webScoketId'] = $cache.get('webScoketId') || getBrowserKey() || '';
        config.headers['webTabScoketId'] = $session.get('webTabScoketId') || '';
        //动态Url
        //console.log(config);
        if (config.serviceName !== defServiceName) {
            let baseURL = serviceUrlHash[config.serviceName] || serviceUrlHash[defServiceName];
            //let url = config.url.slice(config.baseURL.length);
            config.baseURL = baseURL;
            //config.url = baseURL + url;
        }
        return config
    },
    error => {
        // do something with request error
        console.log("请求出错",error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
    */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data
        // if the custom code is not 20000, it is judged as an error.
        if (res.code === undefined || res.code == '200' || res.code == '0' || res.code == '10000' || res.success || res.code == 'success') {
            return res
        } else {
            response.config && response.config.errTip && msg.error(res.message || res.msg || 'Error')

            // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
            if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
                // to re-login
                confirm('Confirm logout', 'You have been logged out, you can cancel to stay on this page, or log in again', {
                    confirmButtonText: 'Re-Login',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(noAuth)
            }
            var error = new Error(res.message || 'Error');
            error.res = res;
            return Promise.reject(error)
        }
    },
    error => {
        //var url = new URL(((error || {}).request || {}).responseURL || location.href);
        if (error && error.response) {
            error.response.data = error.response.data || {};
            msg.error(error.response.data.message || '请求超时，请稍后再试');
            if (error.response.status == 401) {
                //url.pathname == '/login' ||
                if (error.response.data.message === '请先登录') {
                    noAuth();
                }
            }
        } else {
            msg.error('请求超时，请稍后再试');
        }

        return Promise.reject(error)
    }
)
const postFun = (serviceName, errTip, url, data, params) => {
    let option = {
        serviceName: serviceName || defServiceName,
        url: url,
        method: 'post',
        errTip
    };
    if (data) {
        option.data = data;
    }
    if (params) {
        option.params = params;
    }
    return service(option);
};
const getFun = (serviceName, errTip, url, params) => {
    return service({
        serviceName: serviceName || defServiceName,
        url: url,
        method: 'get',
        params,
        errTip
    });
};
Object.keys(serviceUrlHash).forEach(serviceName => {
    service[serviceName] = {
        post: postFun.bind(service, serviceName, true),
        get: getFun.bind(service, serviceName, true),
        noTip: {
            post: postFun.bind(service, serviceName, false),
            get: getFun.bind(service, serviceName, false),
        }
    };
});

//调用缓存
var loadCacheObj = {};
service.loadPe = function (key, fun) {
    return service.loadCache(key, fun, -1);
};
service.loadGlobal = function (key, fun) {
    return service.loadCache(key, fun, "");
};
/**
 * 调用加上缓存，指定时间只调用第一次
 * @param {*} key
 * @param {*} fun
 * @param {*} time 如果为-1，则在请求结束后删除缓存,如果为空，则一直缓存到刷新整个页面
 * @returns
 */
service.loadCache = function (key, fun, time) {
    //初始化参数
    if (key) {
        if (typeof (key) == "function") {
            fun = key;
            key = this.getPageKey("_loadCache");
        } else if (typeof (key) != "string") {
            key = JSON.stringify(key);
        }
    } else {
        key = this.getPageKey("_loadCache");
    }
    if (fun) {
        if (typeof (fun) !== "function") {
            fun = () => Promise.resolve(fun);
        }
    } else {
        fun = () => Promise.reject(null);
    }
    if (!loadCacheObj[key]) {
        loadCacheObj[key] = Promise.resolve(fun());
    }
    //指定时间删除缓存
    if (time) {
        let delFun = () => {
            loadCacheObj[key] = null;
        };
        if (time > 0) {
            setTimeout(delFun, time);
        } else {
            loadCacheObj[key].finally(delFun);
        }
    }
    return loadCacheObj[key];
};
export default service
